import { Button } from "@ui/shad"
import { NotepadTextDashed, Paperclip, Pencil, Pin, Send, X } from "lucide-react"

export default function EmailMessageBackground() {
  return (
    <div className="relative flex h-full max-h-[70vh] w-full flex-col">
      <div className="flex items-center justify-between border-b px-4 py-2">
        <div className="flex flex-none items-center gap-x-2">
          <label className="text-tertiary-foreground w-10 text-sm font-medium">From</label>
          <div className="flex h-6 items-center rounded-md border pr-1 pl-1.5 text-sm">
            <span>sarah.johnson@company.com</span>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <Button size="iconXs" variant="ghost">
            <Pin />
          </Button>
          <Button size="iconXs" variant="ghost">
            <X />
          </Button>
        </div>
      </div>

      <div className="border-b px-4 py-2">
        <div className="flex flex-none items-center gap-x-2">
          <label className="text-tertiary-foreground w-10 text-sm font-medium">To</label>
          <div className="flex h-full grow flex-wrap items-center gap-1.5">
            <div className="flex h-6 items-center rounded-md border pr-1 pl-1.5 text-sm">
              <span>murphy@murphin.com</span>
              <button type="button" className="ml-0.5">
                <span className="text-icon hover:text-destructive text-xs">✕</span>
              </button>
            </div>
            <div className="flex h-6 items-center rounded-md border pr-1 pl-1.5 text-sm">
              <span>someemail@email.com</span>
              <button type="button" className="ml-0.5">
                <span className="text-icon hover:text-destructive text-xs">✕</span>
              </button>
            </div>
          </div>
          <div className="flex items-center space-x-1">
            <button className="bg-muted rounded px-2 py-1 text-xs font-normal">Cc</button>
            <button className="hover:bg-muted rounded px-2 py-1 text-xs font-normal">Bcc</button>
          </div>
        </div>
      </div>

      <div className="border-b px-4 py-2">
        <div className="flex flex-none items-center gap-x-2">
          <label className="text-tertiary-foreground w-10 text-sm font-medium">Cc</label>
          <div className="flex h-full grow flex-wrap items-center gap-1.5">
            <span className="text-muted-foreground text-sm">email@example.com</span>
          </div>
        </div>
      </div>

      <div className="border-b">
        <div className="px-4 py-3">
          <span className="text-input-placeholder font-medium">Add a subject</span>
        </div>
      </div>

      <div className="grow p-4">
        <div className="space-y-4">
          <p className="text-muted-foreground text-sm">Tip: hit / for styles, snippets, and variables</p>
          <div className="space-y-3 text-sm">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et
              dolore magna aliqua.
            </p>
            <p>
              Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
              pariatur.
            </p>
            <p>
              Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom toolbar */}
      <div className="flex justify-between border-t px-4 py-2">
        <div className="flex items-center gap-1">
          <Button size="iconSm" variant="ghost" disabled>
            <Paperclip />
          </Button>
          <Button size="iconSm" variant="ghost" disabled>
            <Pencil />
          </Button>
          <Button size="iconSm" variant="ghost" disabled>
            <NotepadTextDashed />
          </Button>
        </div>
        <div className="flex items-center gap-2">
          <Button>
            <Send />
            Send
          </Button>
        </div>
      </div>
    </div>
  )
}
